import { render, staticRenderFns } from "./housing-data.vue?vue&type=template&id=f8082e9c&scoped=true"
import script from "./housing-data.vue?vue&type=script&lang=js"
export * from "./housing-data.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8082e9c",
  null
  
)

export default component.exports